import React, { useState, useEffect, useRef } from "react";
import "./bet.css";
import imgPrint from "../../assets/venta/imprimir.png";
import imgLogo from "../../assets/logo.png";
import imgDel from "../../assets/venta/ELIMINAR.png";
import imgRepeat from "../../assets/venta/btnrepetir.png";
import btnDirect from "../../assets/venta/btndirecto.png";
import exacta from "../../assets/venta/exacta1.png";
import colocada from "../../assets/venta/colocada1.png";
import all from "../../assets/venta/contodos.png";
import imgEnter from "../../assets/venta/enter2.png";
import btnAhead from "../../assets/venta/btnpalante.png";
import { CalcularApostado } from "../../utils/Calculo-apostado";
import { headers, heightCanvas, url, widthCanvas } from "../../utils/const";
import Dashboad from "../dashboard/Dashboard";
import { Logout } from "../../utils/logout";
import { DoorOpen, DoorOpenFill } from "react-bootstrap-icons";
import Barcode from "react-jsbarcode";
import { socket } from "../../io";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { addSeconds } from "date-fns";
import { getPrinterStatus, ToPrinter } from "../../utils/print";
import { Stage, Layer, Rect, Circle, Text, Group, Image as KonvaImage } from "react-konva";
let betting = [];
const TICKET_VISIBLE_COUNT = 7;
const wt = 50;

// Función para cargar una imagen
const loadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new window.Image();
    img.src = src;
    img.onload = () => resolve(img);
    img.onerror = (err) => reject(err);
  });
};

function Bet() {
  const [sizeRef, setSizeRef] = useState(1024);
  const [firstBet, setFirstBest] = useState("");
  const [secondBet, setSecondBet] = useState("");
  const [thirtBet, setThirdBet] = useState("");
  const [time, setTime] = useState("");
  const [hour, setHour] = useState("");
  const [nextRun, setNextRun] = useState("");
  const [run, setRun] = useState("");
  const [betted, setBetted] = useState(0);
  const [selected, setSelected] = useState({
    p11: "",
    p12: "",
    p13: "",
    p14: "",
    p15: "",
    p16: "",
    p17: "",
    p18: "",
    p21: "",
    p22: "",
    p23: "",
    p24: "",
    p25: "",
    p26: "",
    p27: "",
    p28: "",
    p31: "",
    p32: "",
    p33: "",
    p34: "",
    p35: "",
    p36: "",
    p37: "",
    p38: "",
  });
  const [total, setTotal] = useState(0);
  const [inTeclado, setInTeclado] = useState("");
  const [winner, setWinner] = useState("");
  const [show, setShow] = useState("");
  const [active, setActive] = useState(false);
  const [newTicketList, setNewTicketList] = useState([]);
  const [showTextArea, setShowTextArea] = useState(false);
  const [PrintSt, setPrintSt] = useState();
  const [btnEnter, SetBtnEnter] = useState();
  const [btnRepetir, setBtnRepetir] = useState();
  const [btnOption, setBtnOption] = useState([]);
  const [ticketMessage, setTicketMessage] = useState("");
  const [ticketOverlay, setTicketOverlay] = useState(null);
  const [ticketScrollIndex, setTicketScrollIndex] = useState(0);
  const [showTicket, setShowTicket] = useState(false);
  const [printButtonLocked, setPrintButtonLocked] = useState(false);
  const printLockRef = useRef(false);
  const playVersionRef = useRef(0);
  const repeatRequestRef = useRef(false);
  const dragSelectRef = useRef({ active: false, touched: new Set() });
  const ticketTouchRef = useRef({ active: false, y: 0, residue: 0 });
  const ticketActionRef = useRef({ key: "", time: 0 });
  const pendingDuplicateBetsRef = useRef([]);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [state, setState] = useState(false);
  const [allowBetAmount10, setAllowBetAmount10] = useState(true);
  const [printer,setPrinter] = useState(false);
  const [activePlayers, setActivePlayers] = useState([]);
  const [selectedPresenceId, setSelectedPresenceId] = useState("");
  const [useFreeTicket, setUseFreeTicket] = useState(false);
  const [playerPanelMode, setPlayerPanelMode] = useState("players");
  const [showQrClaim, setShowQrClaim] = useState(false);
  const [qrClaimValue, setQrClaimValue] = useState("");
  const [qrClaimPreview, setQrClaimPreview] = useState(null);
  const [qrClaimBusy, setQrClaimBusy] = useState(false);
  const [qrCameraActive, setQrCameraActive] = useState(false);
  const [qrExpectedPlayer, setQrExpectedPlayer] = useState(null);
  const qrVideoRef = useRef(null);
  const qrStreamRef = useRef(null);
  const selectedPresence = activePlayers.find((presence) => presence._id === selectedPresenceId);
  const playerButtonSlots = Array.from({ length: 16 }, (_, index) => activePlayers[index] || null);
  let contentPrint = "print";
  const imgList = [
    { img: btnDirect, text: "DIRECTO", x: 10, color: `white`, border: `blue`, bg: `red` },
    { img: btnAhead, text: "PATRA Y PALANTE", x: 10, color: `red`, border: `blue`, bg: `` },
    { img: all, text: "CON TODOS", x: 10, color: `black`, border: `blue`, bg: `white` },
    { img: exacta, text: "EXACT", x: 10, color: `white`, border: `blue`, bg: `red` },
    { img: colocada, text: "COLOCA", x: 10, color: `white`, border: `blue`, bg: `red` },
    { img: imgDel, text: "ELIMINAR", x: 10, color: `black`, border: `blue`, bg: `orange` },
    { img: imgPrint, text: "PRINTER", x: 10, color: `yellow`, border: `blue`, bg: `green` },
  ];
  const formatPlayerMinutes = (entry) => {
    const seconds = entry?.expiresInSec || 0;
    return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
  };
  const shouldUseEntryFreeTicket = (entry) => entry?.source === "FREE_TICKET" || (useFreeTicket && entry?.hasFreeTicket);
  const closeQrClaim = () => {
    setShowQrClaim(false);
    setQrCameraActive(false);
    setQrClaimValue("");
    setQrClaimPreview(null);
    setQrExpectedPlayer(null);
  };
  const openQrClaimForPlayer = (event, entry) => {
    if (event) event.cancelBubble = true;
    if (!entry?.hasPendingClaimQr || !entry?.player?._id) return;
    setQrExpectedPlayer({_id:entry.player._id, name:entry.player.name, code:entry.player.code});
    setQrClaimValue("");
    setQrClaimPreview(null);
    setShowQrClaim(true);
  };
  const ProcessQrClaim = async () => {
    if (!qrClaimValue.trim()) return setTicketOverlay({type:"error", title:"QR requerido", message:"Escanee el código QR presentado por el jugador.", confirmLabel:"OK"});
    try {
      setQrClaimBusy(true);
      const response = await fetch(`${url}/ticket/qr/pay`, {
        method:"POST", headers, body:JSON.stringify({qr:qrClaimValue.trim(), expectedPlayerId:qrExpectedPlayer?._id})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data === "string" ? data : data?.msg || "No se pudo validar el QR");
      if (typeof data?.amountToPay === "number") {
        setQrClaimPreview(data);
        return;
      }
      closeQrClaim();
      setActivePlayers((players) => players.map((entry) => String(entry.player?._id) === String(qrExpectedPlayer?._id) ? {...entry, hasPendingClaimQr:false, pendingClaimQr:undefined} : entry));
      setTicketOverlay({type:"success", title:"Pago realizado", message:"El ticket fue pagado correctamente y el QR quedó invalidado.", confirmLabel:"OK"});
    } catch (error) {
      setQrClaimPreview(null);
      setTicketOverlay({type:"error", title:"QR no válido", message:error.message || "No fue posible procesar el cobro.", confirmLabel:"OK"});
    } finally {
      setQrClaimBusy(false);
    }
  };
  useEffect(() => {
    if (!showQrClaim || !qrCameraActive) return undefined;
    let cancelled = false;
    let scanTimerId;
    const start = async () => {
      try {
        if (!window.BarcodeDetector) throw new Error("Este navegador no permite leer QR con cámara. Use un lector QR USB o pegue el código.");
        const detector = new window.BarcodeDetector({formats:["qr_code"]});
        const stream = await navigator.mediaDevices.getUserMedia({video:{facingMode:{ideal:"environment"}}, audio:false});
        qrStreamRef.current = stream;
        if (!qrVideoRef.current || cancelled) return;
        qrVideoRef.current.srcObject = stream;
        await qrVideoRef.current.play();
        const scan = async () => {
          if (cancelled || !qrVideoRef.current) return;
          try {
            const codes = await detector.detect(qrVideoRef.current);
            if (codes[0]?.rawValue) {
              setQrClaimValue(codes[0].rawValue);
              setQrClaimPreview(null);
              setQrCameraActive(false);
              return;
            }
          } catch (_) {}
          scanTimerId = window.setTimeout(scan, 150);
        };
        scan();
      } catch (error) {
        setQrCameraActive(false);
        setTicketOverlay({type:"error", title:"Cámara no disponible", message:error.message || "No se pudo abrir la cámara.", confirmLabel:"OK"});
      }
    };
    start();
    return () => {
      cancelled = true;
      if (scanTimerId) window.clearTimeout(scanTimerId);
      qrStreamRef.current?.getTracks().forEach((track) => track.stop());
      qrStreamRef.current = null;
    };
  }, [showQrClaim, qrCameraActive]);
  useEffect(() => {
    socket.emit("state", localStorage.getItem("point"));
    const handleState = (data) => {
      if (!data) return;
      setState(data.state);
      setAllowBetAmount10(data.allowBetAmount10 !== false);
    };
    socket.on("state-res", handleState);
    return () => socket.off("state-res", handleState);
  }, []);
  useEffect(() => {
    window.addEventListener("mouseup", handleMouseUp);
    return () => {
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);
  useEffect(() => {
    if (localStorage.getItem("level") !== "4") return (window.location.href = "/");
  }, []);
  useEffect(() => {
    const loadActivePlayers = () => {
      fetch(`${url}/player/presence/active`, {
        method: "GET",
        headers,
      })
        .then((res) => res.json())
        .then((data) => {
          const activeList = data.players || data.active || [];
          setActivePlayers(activeList);
          if (!activeList.some((presence) => presence._id === selectedPresenceId)) {
            setSelectedPresenceId("");
            setUseFreeTicket(false);
          }
        })
        .catch(() => {});
    };
    loadActivePlayers();
    const interval = setInterval(loadActivePlayers, 15000);
    return () => clearInterval(interval);
  }, [selectedPresenceId]);
  useEffect(() => {
    let disposed = false;
    const loadPrinterStatus = async () => {
      const data = await getPrinterStatus();
      if (!disposed) setPrinter(data.online !== false);
      void fetch(`${url}/print-status`, {
        headers,
        method: "post",
        body: JSON.stringify(data),
      }).catch(() => {});
    };
    loadPrinterStatus();
    const intervalId = window.setInterval(loadPrinterStatus, 30000);
    return () => { disposed = true; window.clearInterval(intervalId); };
  }, []);
  /**Determinaa le madida mas peque;a de la pantalla para tomar su medida como referencia */
  useEffect(() => {
    const w = window.innerWidth;
    const h = window.innerHeight;
    setSizeRef(w < h ? w : h);
  }, [sizeRef]);
  /**Para cargar imagenes */
  useEffect(() => {
    const loadAllImages = async () => {
      try {
        const allImgPromises = imgList.map((option) => loadImage(option.img).then((img) => ({ ...option, img })));
        const allImg = await Promise.all(allImgPromises);
        setBtnOption(allImg);
        setImagesLoaded(true); // Marcar que todas las imágenes se han cargado
      } catch (err) {
        console.error("Error loading images:", err);
      }
    };

    loadAllImages();
  }, []);
  useEffect(() => {
    const img = new window.Image();
    img.src = imgEnter;
    img.onload = () => SetBtnEnter(img);
  }, []);
  useEffect(() => {
    const img = new window.Image();
    img.src = imgRepeat;
    img.onload = () =>
      setBtnRepetir({
        img: img,
        text: "REPETIR",
        x: 10,
        color: `white`,
        border: `blue`,
        bg: `blue`,
      });
  }, []);
  /** Datos de la Carrera actual para cual sera la apuesta */
  useEffect(() => {
    if (!localStorage.getItem("user")) return (window.location.href = "/");
    const handleScreen = (data) => {
      setTime((value) => {
        if (Number(data.time) <= 10 && Number(value) > 10) {
          setSelected({
            p11: "",
            p12: "",
            p13: "",
            p14: "",
            p15: "",
            p16: "",
            p17: "",
            p18: "",
            p21: "",
            p22: "",
            p23: "",
            p24: "",
            p25: "",
            p26: "",
            p27: "",
            p28: "",
            p31: "",
            p32: "",
            p33: "",
            p34: "",
            p35: "",
            p36: "",
            p37: "",
            p38: "",
          });
          betting = [];
          setTotal(() => 0);
          setFirstBest("");
          setSecondBet("");
          setThirdBet("");
          setBetted(0);
          setNewTicketList([]);
          setTicketMessage("");
          setTicketScrollIndex(0);
          setActive(false);
        }
        return data.time;
      });

      const hr = `${new Date().getHours().toString().padStart(2, "0")}:${new Date().getMinutes().toString().padStart(2, "0")}:${new Date().getSeconds().toString().padStart(2, "0")}`;
      const lasthours = addSeconds(new Date(), data.time);
      setHour(() => hr);
      setNextRun(() => `${lasthours.getHours().toString().padStart(2, "0")}:${lasthours.getMinutes().toString().padStart(2, "0")}:${lasthours.getSeconds().toString().padStart(2, "0")}`);
    };
    /**Socket.Io */
    const handleRun = (data) => setRun(data.run);
    socket.on("screen", handleScreen);
    socket.on("run", handleRun);
    /**Lectura codigo de barra */
    // Agregar el evento al documento cuando el componente se monta
    const handleKeyDown = (event) => {
      if (event.key !== "Enter") {
        const nume = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        if (nume.includes(Number(event.key))) InputTeclado(event.key);
      } else {
        if (event.key === "Enter") setShowTicket(true);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    // Eliminar el evento al documento cuando el componente se desmonta
    return () => {
      socket.off("screen", handleScreen);
      socket.off("run", handleRun);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [PrintSt]);

  if (!localStorage.getItem("user")) {
    return (window.location.href = "/");
  }

  const blankSelection = () => ({
    p11: "",
    p12: "",
    p13: "",
    p14: "",
    p15: "",
    p16: "",
    p17: "",
    p18: "",
    p21: "",
    p22: "",
    p23: "",
    p24: "",
    p25: "",
    p26: "",
    p27: "",
    p28: "",
    p31: "",
    p32: "",
    p33: "",
    p34: "",
    p35: "",
    p36: "",
    p37: "",
    p38: "",
  });

  const updateRowBet = (place, value) => {
    if (place === 1) setFirstBest(value);
    if (place === 2) setSecondBet(value);
    if (place === 3) setThirdBet(value);
  };

  const addValue = (place, num) => {
    setSelected((prevSelected) => {
      const key = `p${place}${num}`;
      const nextSelected = {
        ...prevSelected,
        [key]: prevSelected[key] === "betted" ? "" : "betted",
      };
      const rowValue = [1, 2, 3, 4, 5, 6, 7, 8].filter((dog) => nextSelected[`p${place}${dog}`] === "betted").join("");
      updateRowBet(place, rowValue);
      return nextSelected;
    });
  };

  const toggleRow = (place) => {
    setSelected((prevSelected) => {
      const allSelected = [1, 2, 3, 4, 5, 6, 7, 8].every((dog) => prevSelected[`p${place}${dog}`] === "betted");
      const nextSelected = { ...prevSelected };
      [1, 2, 3, 4, 5, 6, 7, 8].forEach((dog) => {
        nextSelected[`p${place}${dog}`] = allSelected ? "" : "betted";
      });
      updateRowBet(place, allSelected ? "" : "12345678");
      return nextSelected;
    });
  };

  const showBetError = (message) => {
    setTicketMessage(message);
    setTicketOverlay({
      type: "error",
      title: "Error de jugada",
      message,
      confirmLabel: "OK",
    });
  };

  const showPrinterError = (result, ticketNumber) => {
    const messages = {
      offline: "La impresora está desconectada o apagada.",
      timeout: "La impresora no respondió dentro del tiempo esperado.",
      "http-error": `El servicio de impresión respondió con error${result.status ? ` (${result.status})` : ""}.`,
      "print-error": result.detail || "La impresora reportó un fallo al imprimir.",
      "service-unavailable": "No se encontró el servicio local de impresión. Verifique que esté iniciado.",
    };
    setTicketOverlay({
      type: "printer",
      title: "Ticket guardado, no impreso",
      message: `El ticket ${ticketNumber || ""} fue registrado correctamente. ${messages[result.reason] || "No fue posible imprimirlo."}`,
      confirmLabel: "Entendido",
    });
  };

  const printWithFeedback = async (printData, ticketNumber) => {
    const result = await ToPrinter(printData);
    setPrinter(result.printed);
    if (!result.printed) showPrinterError(result, ticketNumber);
    return result;
  };

  const normalizeBetForServer = (item) => ({
    ...item,
    dog: {
      firt: item.dog?.firt?.toString() || "",
      second: item.dog?.second?.toString() || "",
      third: item.dog?.third?.toString() || "",
    },
    amount: Number(item.amount || 0),
    type: item.dog?.second && !item.dog?.third && (item.type?.includes("PATRA") || item.type?.includes("CON TODO")) ? "DIRECTO" : item.type,
  });

  const serializeBetForServer = (item) => ({
    dog: {
      firt: item.dog?.firt?.toString() || "",
      second: item.dog?.second?.toString() || "",
      third: item.dog?.third?.toString() || "",
    },
    amount: Number(item.amount || 0),
    type: item.type,
  });

  const sameBet = (first, second) =>
    first.type === second.type &&
    first.dog.firt === second.dog.firt &&
    first.dog.second === second.dog.second &&
    first.dog.third === second.dog.third;

  const mergeRepeatedBets = (currentBets, incomingBets) => {
    const nextBets = currentBets.map((item) => ({
      ...item,
      dog: { ...item.dog },
      amount: Number(item.amount || 0),
    }));

    incomingBets.forEach((newBet) => {
      const repeatedIndex = nextBets.findIndex((item) => sameBet(item, newBet));
      if (repeatedIndex >= 0) {
        nextBets[repeatedIndex] = {
          ...nextBets[repeatedIndex],
          amount: Number(nextBets[repeatedIndex].amount || 0) + Number(newBet.amount || 0),
        };
      } else {
        nextBets.push(newBet);
      }
    });

    return nextBets;
  };

  const openRepeatedBetOverlay = (expandedBets) => {
    const repeatedCount = expandedBets.filter((newBet) => betting.some((item) => sameBet(item, newBet))).length;
    const newCount = expandedBets.length - repeatedCount;
    pendingDuplicateBetsRef.current = expandedBets;
    setTicketOverlay({
      type: "duplicate",
      title: "Jugada repetida",
      message: `Hay ${repeatedCount} jugada(s) ya digitada(s). Si acepta, se suma el monto a la jugada existente${newCount > 0 ? ` y se agregan ${newCount} nueva(s).` : "."}`,
      confirmLabel: "Sumar monto",
      cancelLabel: "No agregar",
    });
  };

  const selectionFromGrid = () => ({
    first: [1, 2, 3, 4, 5, 6, 7, 8].filter((dog) => selected[`p1${dog}`] === "betted").join(""),
    second: [1, 2, 3, 4, 5, 6, 7, 8].filter((dog) => selected[`p2${dog}`] === "betted").join(""),
    third: [1, 2, 3, 4, 5, 6, 7, 8].filter((dog) => selected[`p3${dog}`] === "betted").join(""),
  });

  const validateBetSelection = (type, selection) => {
    const { first, second, third } = selection;
    if (!first && !second && !third) return "Seleccione al menos un perro antes de agregar la jugada";
    if (type.includes("DIRECTO")) {
      if (!first) return "Directo requiere seleccionar perro en la fila 1";
      if (third) return "Directo no usa la fila 3";
    }
    if (type.includes("PATRA")) {
      if (!first || !second) return "Patra y palante requiere filas 1 y 2";
      if (third) return "Patra y palante no usa la fila 3";
    }
    if (type.includes("CON TODO")) {
      if (!first) return "Con todos requiere seleccionar perro en la fila 1";
      if (second || third) return "Con todos solo usa la fila 1";
    }
    if (type.includes("EXACT") || type.includes("COLOC")) {
      if (!first || !second || !third) return "Tripleta requiere filas 1, 2 y 3";
    }
    return "";
  };

  const buildTicketRows = (bets) => {
    return bets
      .map((z, betIndex) => {
        const first = z.dog.firt;
        const second = z.dog.second;
        const third = z.dog.third;
        const line = z.run?.line;
        let win;
        let pay;
        let dog;

        if (!line) throw new Error("La linea de carrera no esta disponible");
        if (first !== "" && second === "" && third === "") {
          pay = line.d[`p${first}`];
          win = pay * z.amount;
          dog = `G-${first}`;
        } else if (first !== "" && second !== "" && third === "") {
          pay = line[`p${first}${second}`];
          win = pay * z.amount;
          dog = `P-${first}-${second}`;
        } else if (first !== "" && second !== "" && third !== "") {
          pay = z.type.includes("EXAC") ? parseFloat(line[`p${first}${second}`]) * line.d[`p${third}`] : (parseFloat(line[`p${first}${second}`]) * line.d[`p${third}`]) / 5.89;
          win = pay * z.amount;
          dog = z.type.includes("EXAC") ? `TE-${first}-${second}-${third}` : `TC-${first}-${second}-${third}`;
        } else {
          throw new Error("Jugada incorrecta");
        }

        if (!Number.isFinite(Number(pay))) throw new Error("Jugada incorrecta");

        return {
          betIndex,
          amount: z.amount,
          pay: parseFloat(pay).toFixed(2),
          dog,
          win: parseInt(win).toLocaleString("en-EN"),
        };
      })
      .reverse();
  };

  const refreshTicketState = (nextBets, options = {}) => {
    const rows = buildTicketRows(nextBets);
    const maxScroll = Math.max(0, rows.length - TICKET_VISIBLE_COUNT);
    betting = nextBets;
    setNewTicketList(rows);
    setTotal(nextBets.reduce((sum, item) => sum + Number(item.amount || 0), 0));
    setActive(nextBets.length > 0);
    setTicketScrollIndex((current) => (options.showLatest ? 0 : Math.min(current, maxScroll)));
  };

  const resetCurrentSelection = () => {
    setFirstBest("");
    setSecondBet("");
    setThirdBet("");
    setSelected(blankSelection());
    setBetted(0);
  };

  const removeTicketBet = (betIndex) => {
    const nextBets = betting.filter((_, index) => index !== betIndex);
    setTicketMessage("");
    refreshTicketState(nextBets);
  };

  const closeTicketOverlay = (event) => {
    if (event) {
      event.cancelBubble = true;
      event.evt?.preventDefault?.();
    }
    pendingDuplicateBetsRef.current = [];
    setTicketOverlay(null);
    setTicketMessage("");
  };

  const confirmTicketOverlay = (event) => {
    if (event) {
      event.cancelBubble = true;
      event.evt?.preventDefault?.();
    }

    if (ticketOverlay?.type === "duplicate") {
      const nextBets = mergeRepeatedBets(betting, pendingDuplicateBetsRef.current);
      refreshTicketState(nextBets, { showLatest: true });
      resetCurrentSelection();
    }

    pendingDuplicateBetsRef.current = [];
    setTicketOverlay(null);
    setTicketMessage("");
  };
  /**Agregar a jugada */
  const AddBetting = (type) => {
    setShowTextArea(false);
    setTicketMessage("");
    // Read the rendered grid at action time. The mirrored row states can still
    // be one React update behind when the operator clicks an option quickly.
    const currentSelection = selectionFromGrid();
    const bodyBet = {
      dog: { firt: currentSelection.first, second: currentSelection.second, third: currentSelection.third },
      amount: betted > 0 ? betted : 25,
      type: type,
      run: run,
    };

    if (bodyBet.amount <= 1000 && bodyBet.amount > 0) {
      if (bodyBet.amount) {
        const validationError = validateBetSelection(type, currentSelection);
        if (validationError) return showBetError(validationError);

        try {
          const bettedPlusAMount = CalcularApostado(bodyBet, 8);
          if (!bettedPlusAMount || !Array.isArray(bettedPlusAMount.bodyBet) || bettedPlusAMount.bodyBet.length === 0 || !bettedPlusAMount.amount) {
            return showBetError("Jugada incorrecta, favor revise y trate de nuevo");
          }

          const expandedBets = bettedPlusAMount.bodyBet.map(normalizeBetForServer);
          if (expandedBets.some((newBet) => betting.some((item) => sameBet(item, newBet)))) {
            return openRepeatedBetOverlay(expandedBets);
          }

          const nextBets = mergeRepeatedBets(betting, expandedBets);
          refreshTicketState(nextBets, { showLatest: true });
          resetCurrentSelection();
        } catch (error) {
          console.log("Error al agregar jugada:", error);
          showBetError("Jugada incorrecta, favor revise y trate de nuevo");
        }
      } else {
        showBetError("Debes seleccionar el monto apostado");
      }
    } else {
      showBetError("Monto no valido");
    }
  };
  /**Seleccionar el tipo de apuesta  DIRECTO, PATRA Y PALANTE, CON TODO*/

  /**Eliminar */
  const Eliminar = () => {
    if (inTeclado !== "") {
      setShow(true);
    } else {
      setSelected({ p11: "", p12: "", p13: "", p14: "", p15: "", p16: "", p17: "", p18: "", p21: "", p22: "", p23: "", p24: "", p25: "", p26: "", p27: "", p28: "", p31: "", p32: "", p33: "", p34: "", p35: "", p36: "", p37: "", p38: "" });
      betting = [];
      setTotal(() => 0);
      setFirstBest("");
      setSecondBet("");
      setThirdBet("");
      setBetted(0);
      setNewTicketList([]);
      setTicketMessage("");
      setTicketScrollIndex(0);
      setActive(false);
    }
  };

  /**Eliminar Ticket */
  const EliminarTicket = () => {
    setShowTextArea(true);
    fetch(`${url}/ticket/pay`, {
      method: "post",
      headers: headers,
      body: JSON.stringify({ ticket: inTeclado, action: "Delete" }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (typeof data != "string" && !data.msg) {
          setWinner("");
          setWinner(() => data.amountToPay);
        } else if (typeof data == "string") {
          setWinner("");
          setWinner(() => data);
        } else if (data.msg && data.msg.includes("agado")) {
          void printWithFeedback({amountToPay:data.ticket.winner.amountToPay, type:'pago'}, data.ticket?.num);
          setWinner(data.msg);
        }
        if (showTicket === true) {
          setTimeout(() => setShowTicket(false), 150);
          Clear();
        }
        setShow(false);
      });
  };
  /**Realizar apuesta */
  const ToPrint = (playerEntry = selectedPresence) => {
    if (localStorage.getItem("level") !== "4") return (window.location.href = "/");
    if (active === true) {
      if (printLockRef.current || printButtonLocked) return;
      printLockRef.current = true;
      setPrintButtonLocked(true);
      const submittedPlayVersion = playVersionRef.current;
      const entryToPrint = playerEntry || null;
      const entryUsesFreeTicket = shouldUseEntryFreeTicket(entryToPrint);
      const bodyTicket = entryToPrint
        ? {
            bets: betting.map(serializeBetForServer),
            runId: run?._id,
            playerPresenceId: entryToPrint.presenceId || (entryToPrint.source === "ACTIVE" ? entryToPrint._id : undefined),
            playerCode: entryToPrint.player?.code,
            fundSource: entryUsesFreeTicket ? "FREE_TICKET" : "CASH",
            useFreeTicket: entryUsesFreeTicket,
            freeTicketId: entryUsesFreeTicket ? entryToPrint.freeTicketId : undefined,
          }
        : { bets: betting.map(serializeBetForServer), runId: run?._id };
      fetch(`${url}/ticket`, {
        method: "post",
        headers: headers,
        body: JSON.stringify(bodyTicket),
      })
        .then((res) => res.json())
        .then((data) => {
          if (typeof data === "string") {
            showBetError(data);
            return;
          }
          if ((data.message && data.message.includes("allida")) || (data.msg && !data.ticket)) {
            // localStorage.clear()
            // window.location.href = '/'
            showBetError(data.message || data.msg);
          } else {
            if (playVersionRef.current === submittedPlayVersion) {
              refreshTicketState([]);
              resetCurrentSelection();
              setUseFreeTicket(false);
              setSelectedPresenceId("");
              setTicketMessage("");
              setTicketScrollIndex(0);
            }
            contentPrint = "";
            const dataToPrint = { ...(data.ticket || data), type: "ticket", system: "hipico", sys: "D8" };
            void printWithFeedback(dataToPrint, data?.ticket?.num || data?.num);
            setPrintSt(data);
          }
        })
        .catch((error) => {
          console.log("Error:", error);
          showBetError("Error al generar ticket, favor revise la conexión antes de continuar");
        });
    }
  };

  /**Entrada por teclado */
  const InputTeclado = (num) => {
    setInTeclado((value) => `${value}${num}`);
  };
  /**Agregar a monto de apuesta */
  const AddBetAmount = (value) => {
    if (betted + value <= 1000) {
      setBetted((betted) => parseFloat(betted) + parseFloat(value));
    } else {
      showBetError("Apuesta Maxima Superada");
    }
  };
  /**Eliminar el ultimo caracter */
  const Back = () => {
    setInTeclado((value) => value.substring(0, value.length - 1));
  };

  /**Limpia el input del ticket */
  const Clear = () => {
    setInTeclado("");
  };
  /**Enter Para Pago */
  const EnterPay = (action) => {
    const isRepeat = String(action).toLowerCase().includes("repeat");
    if (isRepeat && repeatRequestRef.current) {
      setWinner("Solicitud de repetición ya en proceso");
      return;
    }
    if (isRepeat) repeatRequestRef.current = true;
    const requestHeaders = isRepeat
      ? { ...headers, "x-idempotency-key": window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}` }
      : headers;
    setShowTextArea(true);
    setShowTicket(false);
    fetch(`${url}/ticket/pay`, {
      method: "post",
      headers: requestHeaders,
      body: JSON.stringify({ ticket: inTeclado, action }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (typeof data != "string" && !data.msg) {
          setWinner("");
          setWinner(() => parseInt(data.amountToPay));
        } else if (typeof data == "string") {
          setWinner("");
          setWinner(() => data);
          Clear();
        } else if (data.msg && data.msg.includes("agado")) {
          void printWithFeedback({amountToPay:data.ticket.winner.amountToPay, type:'pago'}, data.ticket?.num);
          setPrintSt(() => data.ticket);
          setWinner(data.msg);
          Clear();
        } else {
          if (data.hasOwnProperty("msg") && data.msg.includes("petid")) {
            setWinner(data.msg);
            const dataToPrint =data.ticket;
            dataToPrint.type ="ticket";
            dataToPrint.system ="hipico"
            dataToPrint.sys ="D8"
            void printWithFeedback(dataToPrint, data.ticket?.num);
            setPrintSt(() => data.ticket);
            setInTeclado("");
          }
        }
      })
      .catch(() => setWinner(isRepeat ? "Error de conexión al repetir el ticket" : "Error de conexión al procesar el ticket"))
      .finally(() => {
        if (isRepeat) repeatRequestRef.current = false;
      });
  };

  /** KONVAS */

  const buttons = [
    { number: 1, x: 50, color: `white`, border: `blue`, bg: `red` },
    { number: 2, x: 170, color: `red`, border: `blue`, bg: `` },
    { number: 3, x: 290, color: `black`, border: `blue`, bg: `white` },
    { number: 4, x: 410, color: `white`, border: `blue`, bg: `blue` },
    { number: 5, x: 530, color: `black`, border: `blue`, bg: `orange` },
    { number: 6, x: 650, color: `yellow`, border: `blue`, bg: `green` },
    { number: 7, x: 770, color: `yellow`, border: `blue`, bg: `black` },
    { number: 8, x: 890, color: `white`, border: `blue`, bg: `violet` },
  ];

  const money = [
    { number: 10, x: 50, color: `white`, border: `blue`, bg: `red` },
    { number: 25, x: 50, color: `red`, border: `blue`, bg: `` },
    { number: 50, x: 50, color: `black`, border: `blue`, bg: `white` },
    { number: 100, x: 50, color: `white`, border: `blue`, bg: `blue` },
    { number: 200, x: 50, color: `white`, border: `blue`, bg: `blue` },
    ...(!allowBetAmount10 ? [{ number: 500, x: 50, color: `white`, border: `blue`, bg: `#7c3aed` }] : []),
  ].filter(({ number }) => number !== 10 || allowBetAmount10);

  const toggleCellDuringDrag = (place, number) => {
    const key = `${place}-${number}`;
    if (dragSelectRef.current.touched.has(key)) return;
    dragSelectRef.current.touched.add(key);
    addValue(place, number);
  };

  const startCellSelection = (place, number) => {
    if (printLockRef.current || printButtonLocked) {
      playVersionRef.current += 1;
      printLockRef.current = false;
      setPrintButtonLocked(false);
      refreshTicketState([]);
      resetCurrentSelection();
      setTicketMessage("");
      setTicketScrollIndex(0);
    }
    dragSelectRef.current = { active: true, touched: new Set() };
    toggleCellDuringDrag(place, number);
  };

  const stopCellSelection = () => {
    dragSelectRef.current.active = false;
    dragSelectRef.current.touched.clear();
  };

  const selectCellFromPointer = (e) => {
    if (!dragSelectRef.current.active) return;
    const pointer = e.target.getStage().getPointerPosition();
    if (!pointer) return;
    const { x, y } = pointer;

    buttons.forEach(({ number }) => {
      for (let layer = 1; layer <= 3; layer++) {
        const rectX = widthCanvas * 0.07 + ((number - 1) * widthCanvas * 0.6) / 8;
        const rectY = heightCanvas * (0.3 + (layer - 1) * 0.12);
        const rectWidth = sizeRef * 0.1;
        const rectHeight = sizeRef * 0.1;
        if (x > rectX && x < rectX + rectWidth && y > rectY && y < rectY + rectHeight) {
          toggleCellDuringDrag(layer, number);
        }
      }
    });
  };

  const handleTouchMove = (e) => {
    selectCellFromPointer(e);
  };

  const NavigatorComp = (path) => {
    window.location.href = path;
  };

  const handleMouseMove = (e) => {
    selectCellFromPointer(e);
  };

  const handleMouseUp = () => {
    stopCellSelection();
  };

  const handleTouchEnd = () => {
    stopCellSelection();
  };
  //OBTINE EL ULTIMO TICKET DE UN PUNTO
  const GetLastTicket = () => {
    fetch(`${url}/ticket/last`, {
      method: "GET",
      headers: headers,
    })
      .then((res) => res.json())
      .then((data) => {
        setInTeclado(data.num);
        Eliminar();
      });
  };
  const visibleTicketCount = TICKET_VISIBLE_COUNT;
  const maxTicketScroll = Math.max(0, newTicketList.length - visibleTicketCount);
  const visibleTicketList = newTicketList.slice(ticketScrollIndex, ticketScrollIndex + visibleTicketCount);
  const ticketScrollPanelTop = heightCanvas * 0.55;
  const ticketScrollTrackY = heightCanvas * 0.095;
  const ticketScrollTrackHeight = heightCanvas * 0.19;
  const ticketScrollThumbHeight =
    newTicketList.length > visibleTicketCount ? Math.max(heightCanvas * 0.035, ticketScrollTrackHeight * (visibleTicketCount / newTicketList.length)) : ticketScrollTrackHeight;
  const ticketScrollThumbTravel = Math.max(1, ticketScrollTrackHeight - ticketScrollThumbHeight);
  const ticketScrollThumbY = ticketScrollTrackY + (maxTicketScroll > 0 ? (ticketScrollIndex / maxTicketScroll) * ticketScrollThumbTravel : 0);
  const ticketScrollTrackX = widthCanvas * 0.237;
  const ticketScrollButtonX = widthCanvas * 0.232;
  const ticketScrollButtonWidth = widthCanvas * 0.017;
  const scrollTicketList = (direction) => {
    setTicketScrollIndex((current) => Math.max(0, Math.min(maxTicketScroll, current + direction)));
  };
  const scrollTicketToIndex = (index) => {
    setTicketScrollIndex(Math.max(0, Math.min(maxTicketScroll, Math.round(index))));
  };
  const stopTicketBubble = (event) => {
    if (event) event.cancelBubble = true;
  };
  const preventTicketEvent = (event) => {
    stopTicketBubble(event);
    event.evt?.preventDefault?.();
  };
  const runTicketActionOnce = (key, action) => {
    const now = Date.now();
    if (ticketActionRef.current.key === key && now - ticketActionRef.current.time < 180) return;
    ticketActionRef.current = { key, time: now };
    action();
  };
  const handleTicketWheel = (event) => {
    preventTicketEvent(event);
    scrollTicketList(event.evt.deltaY > 0 ? 1 : -1);
  };
  const handleTicketTouchStart = (event) => {
    stopTicketBubble(event);
    const touch = event.evt?.touches?.[0];
    if (!touch) return;
    ticketTouchRef.current = { active: true, y: touch.clientY, residue: 0 };
  };
  const handleTicketTouchMove = (event) => {
    const touch = event.evt?.touches?.[0];
    if (!ticketTouchRef.current.active || !touch) return;
    preventTicketEvent(event);
    const deltaY = ticketTouchRef.current.y - touch.clientY;
    const rowHeight = Math.max(18, heightCanvas * 0.04);
    const residue = ticketTouchRef.current.residue + deltaY;
    const steps = Math.trunc(residue / rowHeight);

    if (steps !== 0) {
      scrollTicketList(steps);
      ticketTouchRef.current.residue = residue - steps * rowHeight;
    } else {
      ticketTouchRef.current.residue = residue;
    }
    ticketTouchRef.current.y = touch.clientY;
  };
  const handleTicketTouchEnd = (event) => {
    stopTicketBubble(event);
    ticketTouchRef.current = { active: false, y: 0, residue: 0 };
  };
  const handleTicketRemove = (event, betIndex) => {
    preventTicketEvent(event);
    runTicketActionOnce(`remove-${betIndex}`, () => removeTicketBet(betIndex));
  };
  const handleTicketScrollButton = (event, direction) => {
    preventTicketEvent(event);
    runTicketActionOnce(`scroll-${direction}`, () => scrollTicketList(direction));
  };
  const handleTicketTrackPress = (event) => {
    preventTicketEvent(event);
    const pointer = event.target.getStage()?.getPointerPosition();
    if (!pointer || maxTicketScroll <= 0) return;
    const relativeY = pointer.y - ticketScrollPanelTop;
    const rawIndex = ((relativeY - ticketScrollTrackY - ticketScrollThumbHeight / 2) / ticketScrollThumbTravel) * maxTicketScroll;
    scrollTicketToIndex(rawIndex);
  };
  const handleTicketThumbDragMove = (event) => {
    preventTicketEvent(event);
    if (maxTicketScroll <= 0) return;
    const rawIndex = ((event.target.y() - ticketScrollTrackY) / ticketScrollThumbTravel) * maxTicketScroll;
    scrollTicketToIndex(rawIndex);
  };
  if (!imagesLoaded) {
    return <div className="container fs-3 text-center text-warning">Loading...</div>; // Mostrar un indicador de carga mientras se cargan las imágenes
  }
  /**Mostrar  */

  if (show === "line") {
    return <Dashboad />;
  } else {
    if (time) {
      return (
        <div className="container-fluid vh-100 vw-100">
          <div className="noPrint">
            <Modal show={show} onHide={!show} size="sm" className="" centered>
              <Modal.Header closeButton></Modal.Header>
              <form>
                <Modal.Body>
                  <h3>Desea Anular Ticket {inTeclado}?</h3>
                </Modal.Body>
                <Modal.Footer className="col-12 row justify-content-between">
                  <div className="col">
                    {" "}
                    <button type="button" className="btn btn-warning form-control" onClick={() => setShow(false)}>
                      Cerrar
                    </button>
                  </div>
                  <div className="col">
                    {" "}
                    <button type="button" onClick={EliminarTicket} className="btn btn-danger form-control">
                      {" "}
                      Aceptar{" "}
                    </button>
                  </div>
                </Modal.Footer>
              </form>
            </Modal>
            <Modal show={showTicket} onHide={!showTicket} size="" className="noPrint" centered>
              <Modal.Header>
                <button className="btn btn-close" onClick={() => setShowTicket(false)}></button>
              </Modal.Header>
              <form>
                <Modal.Body className="col-12 text-center fs-1">Ticket: {inTeclado}</Modal.Body>
                <Modal.Footer>
                  <div className="col-12 row">
                    <div className="col">
                      <input className="btn btn-primary form-control fs-3" type="button" onClick={() => EnterPay("pay")} onTouchStart={() => EnterPay("pay")} value={"Pagar"} />
                    </div>

                    <div className="col">
                      <input type="button" className="form-control btn btn-danger fs-3" onClick={Eliminar} value="Eliminar" />
                    </div>
                    <div className="col">
                      <button type="button" className="form-control btn btn-warning fs-3" onClick={() => EnterPay("repeat")}>
                        Repetir
                      </button>
                    </div>
                  </div>
                </Modal.Footer>
              </form>
            </Modal>
            <Modal show={showQrClaim} onHide={closeQrClaim} size="lg" className="noPrint" centered>
              <Modal.Header closeButton className="bg-dark text-white"><Modal.Title>Cobrar QR · {qrExpectedPlayer?.name || "Jugador"} {qrExpectedPlayer?.code ? `(${qrExpectedPlayer.code})` : ""}</Modal.Title></Modal.Header>
              <Modal.Body className="qr-claim-modal">
                <div className="alert alert-info">Este lector está vinculado a <strong>{qrExpectedPlayer?.name}</strong>. Un QR de cualquier otro jugador será rechazado.</div>
                {qrCameraActive ? (
                  <div className="text-center bg-dark rounded p-2"><video ref={qrVideoRef} className="qr-claim-video" muted playsInline /><div className="text-white">Centre el QR dentro de la cámara</div></div>
                ) : (
                  <div className="row g-2">
                    <div className="col-md-9"><input className="form-control form-control-lg" value={qrClaimValue} onChange={(event)=>{setQrClaimValue(event.target.value); setQrClaimPreview(null)}} placeholder="Escanee con lector USB o pegue el código QR" autoFocus /></div>
                    <div className="col-md-3"><button type="button" className="btn btn-outline-primary btn-lg w-100" onClick={()=>setQrCameraActive(true)}>Abrir cámara</button></div>
                  </div>
                )}
                {qrClaimPreview && <div className="qr-claim-confirm mt-3"><span>Ticket ganador validado</span><strong>RD$ {Number(qrClaimPreview.amountToPay).toLocaleString("en-EN", {minimumFractionDigits:2})}</strong><small>Confirme únicamente después de entregar el efectivo.</small></div>}
              </Modal.Body>
              <Modal.Footer>
                <button type="button" className="btn btn-secondary btn-lg" onClick={closeQrClaim}>Cancelar</button>
                <button type="button" className={`btn ${qrClaimPreview ? "btn-success" : "btn-primary"} btn-lg`} disabled={qrClaimBusy || !qrClaimValue.trim()} onClick={ProcessQrClaim}>{qrClaimBusy ? "Procesando..." : qrClaimPreview ? "Confirmar y pagar" : "Validar QR"}</button>
              </Modal.Footer>
            </Modal>
            {state ? (
              <>
              <div className="pos-player-strip">
                <div className={`pos-printer-status ${printer ? "is-online" : "is-offline"}`} title={printer ? "Impresora conectada" : "Impresora desconectada"}>
                  <i aria-hidden="true" />
                  <span>IMPRESORA</span>
                  <strong>{printer ? "OK" : "DESCONECTADA"}</strong>
                </div>
                <select aria-label="Jugador del ticket" title={selectedPresence?.player?.name || "Ticket normal"} value={selectedPresenceId} onChange={(event) => { setSelectedPresenceId(event.target.value); setUseFreeTicket(false); }}>
                  <option value="">Ticket normal</option>
                  {activePlayers.map((presence) => (
                    <option key={presence._id} value={presence._id}>
                      {presence.player?.name} - {presence.player?.code}{presence.source === "FREE_TICKET" ? " - Free" : ""}
                    </option>
                  ))}
                </select>
                <button type="button" className={useFreeTicket ? "is-active" : ""} disabled={!selectedPresence?.hasFreeTicket} onClick={() => setUseFreeTicket((value) => !value)}>
                  Free ticket
                </button>
              </div>
              <Stage width={widthCanvas} height={heightCanvas} onTouchMove={handleTouchMove} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp} onTouchEnd={handleTouchEnd} onMouseLeave={handleMouseUp}>
                {/**Layer Header */}
                <Layer>
                  <Group width={widthCanvas} height={heightCanvas * 0.08} x={0} y={0}>
                    {/* Fondo azul */}
                    <Rect
                      width={widthCanvas}
                      height={heightCanvas * 0.08}
                      x={0}
                      y={0}
                      fill="blue" // Color de fondo azul
                    />

                    {/* Rectángulos con nombres */}
                    {[
                      { name: "Venta", x: wt, to: "/bet" },
                      { name: "Linea", x: wt, to: "/line" },
                      { name: "Linea Pale", x: wt, to: "/line-pale" },
                      { name: "Volumen de Venta", x: wt, to: "/venta" }, 
                      { name: "Jugadores", x: wt, to: "/player" },
                      // { name: "Loteria", x: wt, to: "/lotery-bet" },
                    ].map(({ name, to }, index) => (
                        <Group key={to} width={widthCanvas * 0.15} height={heightCanvas * 0.06} x={widthCanvas * 0.15 * index} y={0} onTap={() => NavigatorComp(to)} onClick={() => NavigatorComp(to)}>
                          <React.Fragment>
                            {/* Rectángulo */}
                            <Rect
                              x={0}
                              y={heightCanvas * 0.01}
                              width={widthCanvas * 0.12}
                              height={heightCanvas * 0.05}
                              fill={name==""?"": name=="Fail Printer"?"yellow":"red"}
                              stroke="black"
                              strokeWidth={5}
                              cornerRadius={20} // Bordes redondeados
                            />
                            {/* Texto con nombre */}
                            <Text
                              text={name}
                              fontSize={sizeRef * 0.02}
                              fill={name==""?"": name=="Fail Printer"?"red":"white"}
                              x={0}
                              y={heightCanvas * 0.01}
                              width={widthCanvas * 0.12}
                              height={heightCanvas * 0.05}
                              align="center"
                              verticalAlign="middle"
                              padding={sizeRef * 0.01} // Ajuste del texto dentro del rectángulo
                              stroke={name==""?"": name=="Fail Printer"?"red":"white"}
                              strokeWidth={1.2}
                              fontFamily="Arial"
                            />
                          </React.Fragment>
                        </Group>
                    ))}
                  </Group>
                </Layer>
                {/**Layer Generico */}
                <Layer>
                  <Group x={0} y={heightCanvas * 0.071} width={widthCanvas} height={heightCanvas * 0.1}>
                    <Group x={0} y={heightCanvas * 0.02} width={widthCanvas * 0.2} height={heightCanvas * 0.1}>
                      <Text text="Carrera" x={0} y={0} width={widthCanvas * 0.2} height={heightCanvas * 0.03} fontSize={sizeRef * 0.03} fontFamily="Arial" fill="white" align="center" verticalAlign="top" />
                      <Text text={run ? run.code : ""} x={0} y={heightCanvas * 0.03} width={widthCanvas * 0.2} height={heightCanvas * 0.1} fontSize={sizeRef * 0.04} fontFamily="Arial" fill="white" align="center" verticalAlign="top" />
                    </Group>
                    <Group x={widthCanvas * 0.25} y={heightCanvas * 0.02} width={widthCanvas * 0.2} height={heightCanvas * 0.1}>
                      <Text text="Inicia" x={0} y={0} width={widthCanvas * 0.2} height={heightCanvas * 0.03} fontSize={sizeRef * 0.03} fontFamily="Arial" fill="white" align="center" verticalAlign="top" />
                      <Text text={nextRun} x={0} y={heightCanvas * 0.03} width={widthCanvas * 0.2} height={heightCanvas * 0.1} fontSize={sizeRef * 0.04} fontFamily="Arial" fill="white" align="center" verticalAlign="top" />
                    </Group>
                    <Group x={widthCanvas * 0.5} y={heightCanvas * 0.02} width={heightCanvas * 0.2} height={heightCanvas * 0.1}>
                      <Text text="Actual" x={0} y={0} width={widthCanvas * 0.2} height={heightCanvas * 0.1} fontSize={sizeRef * 0.03} fontFamily="Arial" fill="white" align="center" verticalAlign="top" />
                      <Text text={hour} x={0} y={heightCanvas * 0.03} width={widthCanvas * 0.2} height={heightCanvas * 0.1} fontSize={sizeRef * 0.04} fontFamily="Arial" fill="white" align="center" verticalAlign="top" />
                    </Group>
                    <Group x={widthCanvas * 0.68} y={heightCanvas * 0.02} width={widthCanvas * 0.12} height={heightCanvas * 0.1} onClick={GetLastTicket} onTap={GetLastTicket}>
                      <Rect x={0} y={0} width={widthCanvas * 0.12} height={heightCanvas * 0.1} fill="gray" cornerRadius={20} stroke={'black'} strokeWidth={6} />
                      <Text text={"Eliminar Ultimo Ticket"} x={0} y={0} width={widthCanvas * 0.12} height={heightCanvas * 0.1} fontSize={sizeRef * 0.025} fontFamily="Arial" fill="yellow" align="center" verticalAlign="middle" listening={false} />
                    </Group>
                    <Group x={widthCanvas * 0.8} y={heightCanvas * 0.02} width={widthCanvas * 0.2} height={heightCanvas * 0.1}>
                      <Text text="Segundos" x={0} y={0} width={widthCanvas * 0.2} height={heightCanvas * 0.1} fontSize={sizeRef * 0.03} fontFamily="Arial" fill="white" align="center" verticalAlign="top" />
                      <Text text={time} x={0} y={heightCanvas * 0.03} width={widthCanvas * 0.2} height={heightCanvas * 0.1} fontSize={sizeRef * 0.04} fontFamily="Arial" fill="white" align="center" verticalAlign="top" />
                    </Group>
                  </Group>
                  {/** Data Bet and Ticket*/}

                  <Group x={widthCanvas * 0.1} y={heightCanvas * 0.18} width={widthCanvas * 0.6} height={heightCanvas * 0.071}>
                    <Group x={0} y={0} width={widthCanvas * 0.1} height={heightCanvas * 0.071}>
                      <Text x={0} y={0} text="Valor Jugada Actual" width={widthCanvas * 0.3} height={heightCanvas * 0.03} fill="white" fontSize={sizeRef * 0.03} verticalAlign="botton" />
                      <Rect x={0} y={heightCanvas * 0.035} width={widthCanvas * 0.2} height={heightCanvas * 0.06} fill="white" cornerRadius={10} />
                      <Text text={betted} x={0} y={heightCanvas * 0.035} fontSize={sizeRef * 0.05} width={widthCanvas * 0.2} height={heightCanvas * 0.06} fill="black" align="center" verticalAlign="middle" />
                    </Group>
                    <Group x={widthCanvas * 0.3} y={0} width={widthCanvas * 0.1} height={heightCanvas * 0.071}>
                      <Text text="Valor Ticket Actual" x={0} y={0} width={widthCanvas * 0.3} height={heightCanvas * 0.03} fill="white" fontSize={sizeRef * 0.03} verticalAlign="botton" />
                      <Rect x={0} y={heightCanvas * 0.035} width={widthCanvas * 0.2} height={heightCanvas * 0.06} fill="white" cornerRadius={10} />
                      <Text text={total} x={0} y={heightCanvas * 0.035} fontSize={sizeRef * 0.05} width={widthCanvas * 0.2} height={heightCanvas * 0.06} fill="black" align="center" verticalAlign="middle" />
                    </Group>
                  </Group>
                </Layer>

                <Layer>
                  {/* Layer BOTTONES 1 */}
                  <Group x={0} y={heightCanvas * 0.3} width={widthCanvas * 0.7} height={heightCanvas * 0.1}>
                    <Group x={0} y={0} width={widthCanvas * 0.05} height={heightCanvas * 0.1} onMouseDown={() => toggleRow(1)} onTouchStart={() => toggleRow(1)}>
                      <Rect x={0} y={0} width={widthCanvas * 0.052} height={heightCanvas * 0.1} fill="rgba(0,0,0,0.2)" stroke="yellow" strokeWidth={1} cornerRadius={8} />
                      <Text text="1" fontSize={sizeRef / 10} fill="white" x={0} y={0} align="left" verticalAlign="middle" width={widthCanvas * 0.05} height={heightCanvas * 0.1} />
                      <Text text="0" fontSize={sizeRef / 20} fill="white" x={0} y={0} align="right" verticalAlign="top" width={widthCanvas * 0.05} height={heightCanvas * 0.1} />
                    </Group>
                    {buttons.map(({ number, color, border, bg }, index) => (
                      <React.Fragment key={`1${number}`}>
                        <Group x={widthCanvas * 0.07 + (index * widthCanvas * 0.6) / 8} y={0} width={sizeRef * 0.1} height={sizeRef * 0.1} onMouseDown={() => startCellSelection(1, number)} onTouchStart={() => startCellSelection(1, number)}>
                          <Rect x={0} y={0} width={sizeRef * 0.1} height={sizeRef * 0.1} fill={selected[`p1${number}`] === "betted" ? "gray" : bg} stroke={border} strokeWidth={2} cornerRadius={10} />
                          <Text text={number.toString()} fontSize={sizeRef / 10} fill={selected[`p1${number}`] === "betted" ? "brown" : color} x={0} y={0} align="center" verticalAlign="middle" width={sizeRef * 0.1} height={sizeRef * 0.1} />
                        </Group>
                      </React.Fragment>
                    ))}
                  </Group>

                  {/* Layer BOTTONES 2 */}
                  <Group x={0} y={heightCanvas * 0.42} width={widthCanvas * 0.7} height={heightCanvas * 0.1}>
                    <Group x={0} y={0} width={widthCanvas * 0.05} height={heightCanvas * 0.1} onMouseDown={() => toggleRow(2)} onTouchStart={() => toggleRow(2)}>
                      <Rect x={0} y={0} width={widthCanvas * 0.052} height={heightCanvas * 0.1} fill="rgba(0,0,0,0.2)" stroke="yellow" strokeWidth={1} cornerRadius={8} />
                      <Text text="2" fontSize={sizeRef / 10} fill="white" x={0} y={0} align="left" verticalAlign="middle" width={widthCanvas * 0.05} height={heightCanvas * 0.1} />
                      <Text text="0" fontSize={sizeRef / 20} fill="white" x={0} y={0} align="right" verticalAlign="top" width={widthCanvas * 0.05} height={heightCanvas * 0.1} />
                    </Group>
                    {buttons.map(({ number, color, border, bg }, index) => (
                      <React.Fragment key={`2${number}`}>
                        <Group x={widthCanvas * 0.07 + (index * widthCanvas * 0.6) / 8} y={0} width={sizeRef * 0.1} height={sizeRef * 0.1} onMouseDown={() => startCellSelection(2, number)} onTouchStart={() => startCellSelection(2, number)}>
                          <Rect x={0} y={0} width={sizeRef * 0.1} height={sizeRef * 0.1} fill={selected[`p2${number}`] === "betted" ? "gray" : bg} stroke={border} strokeWidth={2} cornerRadius={10} />
                          <Text text={number.toString()} fontSize={sizeRef / 10} fill={selected[`p2${number}`] === "betted" ? "brown" : color} x={0} y={0} align="center" verticalAlign="middle" width={sizeRef * 0.1} height={sizeRef * 0.1} />
                        </Group>
                      </React.Fragment>
                    ))}
                  </Group>

                  {/* Layer BOTTONES 3 */}
                  <Group x={0} y={heightCanvas * 0.54} width={widthCanvas * 0.7} height={heightCanvas * 0.1}>
                    <Group x={0} y={0} width={widthCanvas * 0.07} height={heightCanvas * 0.1} onMouseDown={() => toggleRow(3)} onTouchStart={() => toggleRow(3)}>
                      <Rect x={0} y={0} width={widthCanvas * 0.052} height={heightCanvas * 0.1} fill="rgba(0,0,0,0.2)" stroke="yellow" strokeWidth={1} cornerRadius={8} />
                      <Text text="3" fontSize={sizeRef / 10} fill="white" x={0} y={0} align="left" verticalAlign="middle" width={widthCanvas * 0.05} height={heightCanvas * 0.1} />
                      <Text text="0" fontSize={sizeRef / 20} fill="white" x={0} y={0} align="right" verticalAlign="top" width={widthCanvas * 0.05} height={heightCanvas * 0.1} />
                    </Group>
                    {buttons.map(({ number, color, border, bg }, index) => (
                      <React.Fragment key={`3${number}`}>
                        <Group x={widthCanvas * 0.07 + (index * widthCanvas * 0.6) / 8} y={0} width={sizeRef * 0.1} height={sizeRef * 0.1} onMouseDown={() => startCellSelection(3, number)} onTouchStart={() => startCellSelection(3, number)}>
                          <Rect x={0} y={0} width={sizeRef * 0.1} height={sizeRef * 0.1} fill={selected[`p3${number}`] === "betted" ? "gray" : bg} stroke={border} strokeWidth={2} cornerRadius={10} />
                          <Text text={number.toString()} fontSize={sizeRef / 10} fill={selected[`p3${number}`] === "betted" ? "brown" : color} x={0} y={0} align="center" verticalAlign="middle" width={sizeRef * 0.1} height={sizeRef * 0.1} />
                        </Group>
                      </React.Fragment>
                    ))}
                  </Group>
                </Layer>
                {/**money */}
                <Layer>
                  <Group x={0} y={heightCanvas * 0.67} width={widthCanvas * 0.7} height={heightCanvas * 0.12}>
                    {money.map(({ number, x, color, border, bg }, index) => (
                      <React.Fragment key={number}>
                        <Group x={widthCanvas * 0.05 + index * widthCanvas * 0.10} y={0} width={widthCanvas * 0.09} height={heightCanvas * 0.12}>
                          <Rect x={0} y={0} width={widthCanvas * 0.09} height={heightCanvas * 0.12} fill={number === 500 ? "#7c3aed" : "green"} stroke={border} strokeWidth={2} cornerRadius={10} onMouseDown={() => AddBetAmount(number)} onTouchStart={() => AddBetAmount(number)} />
                          <Text text={number.toString()} fontSize={sizeRef / 12.5} fill={"white"} x={0} y={0} align="center" verticalAlign="middle" width={widthCanvas * 0.09} height={heightCanvas * 0.12} listening={false} />
                        </Group>
                      </React.Fragment>
                    ))}
                    {btnEnter && <KonvaImage image={btnEnter} x={widthCanvas * 0.62 - sizeRef * 0.1} y={0} width={sizeRef * 0.2} height={sizeRef * 0.12} onClick={() => EnterPay("pay")} onTouchStart={() => EnterPay("pay")} />}
                  </Group>
                  {/**Option  */}
                  <Group x={widthCanvas * 0.05} y={heightCanvas - heightCanvas * 0.18} width={widthCanvas * 0.7} height={heightCanvas * 0.15}>
                    {btnOption && btnOption.length ? (
                      btnOption.map(({ x, text, img }, index) => (
                        <Group key={text} x={(widthCanvas * index * 0.7) / 8} y={0} width={(widthCanvas * index * 0.7) / 8} height={heightCanvas * 0.15}>
                          <KonvaImage image={img} x={0} y={0} width={((widthCanvas * 0.7) / 8) * 0.9} height={heightCanvas * 0.1} opacity={text.includes("PRIN") && printButtonLocked ? 0.35 : 1} onTouchStart={() => (text.includes("DIREC") || text.includes("EXAC") || text.includes("COLOC") || text.includes("PATRA") || text.includes("TODO") ? AddBetting(text) : text.includes("PRIN") ? ToPrint() : text.includes("REPETIR") ? undefined : Eliminar())} onClick={() => (text.includes("DIREC") || text.includes("EXAC") || text.includes("COLOC") || text.includes("PATRA") || text.includes("TODO") ? AddBetting(text) : text.includes("PRIN") ? ToPrint() : text.includes("REPETIR") ? EnterPay("repeat") : Eliminar())} />
                        </Group>
                      ))
                    ) : (
                      <Text text="" />
                    )}
                  </Group>
                </Layer>
                {/**Ticket */}
                <Layer>
                  <Group x={widthCanvas * 0.71} y={heightCanvas * 0.2} width={widthCanvas * 0.25} height={heightCanvas * 0.6}>
                    {/* Grupo 1: Rectángulo con esquinas redondeadas y texto */}
                    <Group x={0} y={0}>
                      <Rect x={widthCanvas * 0.01} y={0} width={widthCanvas * 0.25 * 0.6} height={heightCanvas / 15} fill="white" cornerRadius={10} />
                      <Text text={inTeclado.length > 0 ? inTeclado : "Entre Ticket"} fontSize={sizeRef / 30} width={widthCanvas * 0.25 * 0.6} height={heightCanvas / 15} verticalAlign="middle" fill="black" x={0} y={0} align="center" />
                      {btnRepetir && <KonvaImage image={btnRepetir.img} x={(widthCanvas * 0.15) / 8 + widthCanvas * 0.3 * 0.5} y={-heightCanvas * 0.02} width={widthCanvas * 0.08} height={heightCanvas / 10} onClick={() => EnterPay("repeat")} />}
                    </Group>

                    {/* Grupo 2: Jugadores / teclado */}
                    <Group x={0} y={heightCanvas * 0.08}>
                      {[
                        { key: "players", label: "Jugadores" },
                        { key: "keyboard", label: "Teclado" },
                      ].map((tab, index) => (
                        <Group key={tab.key} x={index * widthCanvas * 0.125} y={0} width={widthCanvas * 0.12} height={heightCanvas * 0.045} onClick={() => setPlayerPanelMode(tab.key)} onTouchStart={() => setPlayerPanelMode(tab.key)}>
                          <Rect x={0} y={0} width={widthCanvas * 0.12} height={heightCanvas * 0.04} fill={playerPanelMode === tab.key ? "blue" : "lightgrey"} stroke="black" cornerRadius={5} />
                          <Text text={tab.label} fontSize={sizeRef / 45} width={widthCanvas * 0.12} height={heightCanvas * 0.04} fill={playerPanelMode === tab.key ? "white" : "black"} align="center" verticalAlign="middle" />
                        </Group>
                      ))}
                    </Group>
                    <Group x={0} y={heightCanvas * 0.13}>
                      <Rect x={0} y={-heightCanvas * 0.01} width={widthCanvas * 0.25} height={heightCanvas * 0.385} fill="white" />
                      {playerPanelMode === "players" ? (
                        playerButtonSlots.map((entry, index) => (
                          <Group key={entry?._id || `empty-player-${index}`} x={((index % 4) * widthCanvas * 0.23) / 4 + widthCanvas * 0.01} y={Math.floor(index / 4) * heightCanvas * 0.091} width={(widthCanvas * 0.23) / 4} height={heightCanvas * 0.085} onClick={() => entry && ToPrint(entry)} onTouchStart={() => entry && ToPrint(entry)}>
                            <Rect x={0} y={0} width={(widthCanvas * 0.22) / 4} height={heightCanvas * 0.083} fill={entry ? (entry.source === "FREE_TICKET" ? "#f5c84b" : "#143f8f") : "#e8e8e8"} stroke={entry && selectedPresenceId === entry._id ? "yellow" : "black"} strokeWidth={entry && selectedPresenceId === entry._id ? 4 : 1} cornerRadius={5} />
                            <Text text={entry ? entry.player?.code || "---" : ""} fontSize={sizeRef / 48} width={(widthCanvas * 0.22) / 4} height={heightCanvas * 0.026} fill={entry?.source === "FREE_TICKET" ? "black" : "white"} x={0} y={heightCanvas * 0.004} align="center" verticalAlign="middle" fontStyle="bold" />
                            <Text text={entry ? (entry.player?.name || "Jugador").slice(0, 13) : "---"} fontSize={sizeRef / 62} width={(widthCanvas * 0.22) / 4} height={heightCanvas * 0.028} fill={entry?.source === "FREE_TICKET" ? "black" : "white"} x={0} y={heightCanvas * 0.029} align="center" verticalAlign="middle" />
                            <Text text={entry ? (entry.source === "FREE_TICKET" ? `FREE ${entry.freeTicketAmount || ""}` : formatPlayerMinutes(entry)) : ""} fontSize={sizeRef / 72} width={(widthCanvas * 0.22) / 4} height={heightCanvas * 0.022} fill={entry?.source === "FREE_TICKET" ? "black" : "#f5c84b"} x={0} y={heightCanvas * 0.058} align="center" verticalAlign="middle" />
                            {entry?.hasPendingClaimQr && <Group x={(widthCanvas * 0.22) / 4 - widthCanvas * 0.018} y={-heightCanvas * 0.006} width={widthCanvas * 0.022} height={heightCanvas * 0.032} onClick={(event)=>openQrClaimForPlayer(event, entry)} onTap={(event)=>openQrClaimForPlayer(event, entry)}>
                              <Rect x={0} y={0} width={widthCanvas * 0.021} height={heightCanvas * 0.03} fill="#b91c1c" stroke="#facc15" strokeWidth={2} cornerRadius={8} shadowColor="#ef4444" shadowBlur={8} shadowOpacity={0.9} />
                              <Text text="QR" x={0} y={0} width={widthCanvas * 0.021} height={heightCanvas * 0.03} fill="white" fontSize={sizeRef / 78} fontStyle="bold" align="center" verticalAlign="middle" />
                            </Group>}
                          </Group>
                        ))
                      ) : (
                        ["1", "2", "3", "A", "4", "5", "6", "B", "7", "8", "9", "C", "CL", "0", "<--", "D"].map((char, index) => (
                          <Group key={index} x={((index % 4) * widthCanvas * 0.23) / 4 + widthCanvas * 0.01} y={Math.floor(index / 4) * heightCanvas * 0.091} width={(widthCanvas * 0.23) / 4} height={heightCanvas * 0.085}>
                            <Rect x={0} y={0} width={(widthCanvas * 0.22) / 4} height={heightCanvas * 0.083} fill="lightgrey" stroke="black" cornerRadius={5} />
                            <Text text={char} fontSize={sizeRef / 24} width={(widthCanvas * 0.22) / 4} height={heightCanvas * 0.083} fill="black" x={0} y={0} align="center" verticalAlign="middle" onClick={() => (char.includes("-") ? Back() : char.includes("CL") ? Clear() : InputTeclado(char))} onTouchStart={() => (char.includes("-") ? Back() : char.includes("CL") ? Clear() : InputTeclado(char))} />
                          </Group>
                        ))
                      )}
                    </Group>

                    {/* Grupo 3: Tabla con encabezado y filas dinámicas */}
                    <Group x={0} y={heightCanvas * 0.55} onWheel={handleTicketWheel} onTouchStart={handleTicketTouchStart} onTouchMove={handleTicketTouchMove} onTouchEnd={handleTicketTouchEnd}>
                      <Rect x={0} y={0} width={widthCanvas * 0.25} height={heightCanvas * 0.4} fill="lightblue" cornerRadius={10} />
                      <Group x={widthCanvas * 0.01} y={heightCanvas * 0.01} width={widthCanvas * 0.25} height={heightCanvas * 0.04}>
                        <Text text="#" x={0} width={widthCanvas * 0.02} align="center" fontSize={sizeRef / 50} />
                        <Text text="Jugada" x={widthCanvas * 0.021} width={widthCanvas * 0.05} align="center" fontSize={sizeRef / 50} />
                        <Text text="Apostado" x={widthCanvas * 0.072} width={widthCanvas * 0.06} align="center" fontSize={sizeRef / 50} />
                        <Text text="Gana" x={widthCanvas * 0.123} width={widthCanvas * 0.06} align="center" fontSize={sizeRef / 50} />
                        <Text text="Total" x={widthCanvas * 0.172} width={widthCanvas * 0.05} align="center" fontSize={sizeRef / 50} />
                        <Text text="X" x={widthCanvas * 0.213} width={widthCanvas * 0.02} align="center" fontSize={sizeRef / 50} fill="red" />
                      </Group>
                      <Group>
                        {showTextArea ? (
                          <Group x={0} y={heightCanvas * 0.03} width={widthCanvas * 0.25}>
                            <Text text={winner.toString()} fontSize={sizeRef / 30} x={0} y={heightCanvas * 0.01} width={widthCanvas * 0.25} align="center" />
                          </Group>
                        ) : (
                          visibleTicketList.map((row, index) => (
                            <Group key={`${row.betIndex}-${row.dog}`} x={widthCanvas * 0.001} y={(index + 1) * heightCanvas * 0.04}>
                              <Text text={ticketScrollIndex + index + 1} x={widthCanvas * 0.01} width={widthCanvas * 0.02} align="center" />
                              <Text text={row.dog.toString()} x={widthCanvas * 0.03} width={widthCanvas * 0.05} align="center" />
                              <Text text={row.amount.toString()} x={widthCanvas * 0.08} width={widthCanvas * 0.05} align="center" fontFamily="Arial" fontStyle="bold" stroke="black" strokeWidth={0.35} />
                              <Text text={row.pay.toString()} x={widthCanvas * 0.13} width={widthCanvas * 0.05} align="center" fontFamily="Arial" fontStyle="bold" stroke="black" strokeWidth={0.35} />
                              <Text text={row.win.toString()} x={widthCanvas * 0.18} width={widthCanvas * 0.05} align="center" fontFamily="Arial" fontStyle="bold" stroke="black" strokeWidth={0.35} />
                              <Group x={widthCanvas * 0.214} y={-heightCanvas * 0.004} width={widthCanvas * 0.02} height={heightCanvas * 0.035} onClick={(event) => handleTicketRemove(event, row.betIndex)} onTap={(event) => handleTicketRemove(event, row.betIndex)}>
                                <Rect x={0} y={0} width={widthCanvas * 0.018} height={heightCanvas * 0.032} fill="red" cornerRadius={4} stroke="black" strokeWidth={1} />
                                <Text text="X" x={0} y={0} width={widthCanvas * 0.018} height={heightCanvas * 0.032} fill="white" align="center" verticalAlign="middle" fontSize={sizeRef / 70} />
                              </Group>
                            </Group>
                          ))
                        )}
                      </Group>
                      {ticketMessage && <Text text={ticketMessage} x={widthCanvas * 0.005} y={heightCanvas * 0.345} width={widthCanvas * 0.24} height={heightCanvas * 0.045} fill="red" fontSize={sizeRef / 55} align="center" verticalAlign="middle" />}
                      {newTicketList.length > visibleTicketCount && (
                        <>
                          <Group x={ticketScrollButtonX} y={heightCanvas * 0.055} width={ticketScrollButtonWidth} height={heightCanvas * 0.035} onClick={(event) => handleTicketScrollButton(event, -1)} onTap={(event) => handleTicketScrollButton(event, -1)}>
                            <Rect x={0} y={0} width={ticketScrollButtonWidth} height={heightCanvas * 0.032} fill={ticketScrollIndex > 0 ? "blue" : "gray"} cornerRadius={4} stroke="black" strokeWidth={1} />
                            <Text text="^" x={0} y={0} width={ticketScrollButtonWidth} height={heightCanvas * 0.032} fill="white" align="center" verticalAlign="middle" fontSize={sizeRef / 62} />
                          </Group>
                          <Group onClick={handleTicketTrackPress} onTap={handleTicketTrackPress}>
                            <Rect x={ticketScrollTrackX - widthCanvas * 0.003} y={ticketScrollTrackY - heightCanvas * 0.006} width={widthCanvas * 0.014} height={ticketScrollTrackHeight + heightCanvas * 0.012} fill="rgba(255,255,255,0.35)" stroke="black" strokeWidth={1} cornerRadius={6} />
                            <Rect x={ticketScrollTrackX + widthCanvas * 0.002} y={ticketScrollTrackY} width={widthCanvas * 0.004} height={ticketScrollTrackHeight} fill="#6388ad" cornerRadius={4} />
                          </Group>
                          <Group
                            x={ticketScrollTrackX - widthCanvas * 0.0025}
                            y={ticketScrollThumbY}
                            width={widthCanvas * 0.013}
                            height={ticketScrollThumbHeight}
                            draggable
                            dragBoundFunc={(pos) => ({
                              x: ticketScrollTrackX - widthCanvas * 0.0025,
                              y: Math.max(ticketScrollPanelTop + ticketScrollTrackY, Math.min(ticketScrollPanelTop + ticketScrollTrackY + ticketScrollThumbTravel, pos.y)),
                            })}
                            onDragMove={handleTicketThumbDragMove}
                            onClick={stopTicketBubble}
                            onTap={stopTicketBubble}
                          >
                            <Rect x={0} y={0} width={widthCanvas * 0.013} height={ticketScrollThumbHeight} fill="#003fbd" stroke="white" strokeWidth={1} cornerRadius={5} />
                          </Group>
                          <Group x={ticketScrollButtonX} y={heightCanvas * 0.305} width={ticketScrollButtonWidth} height={heightCanvas * 0.035} onClick={(event) => handleTicketScrollButton(event, 1)} onTap={(event) => handleTicketScrollButton(event, 1)}>
                            <Rect x={0} y={0} width={ticketScrollButtonWidth} height={heightCanvas * 0.032} fill={ticketScrollIndex < maxTicketScroll ? "blue" : "gray"} cornerRadius={4} stroke="black" strokeWidth={1} />
                            <Text text="v" x={0} y={0} width={ticketScrollButtonWidth} height={heightCanvas * 0.032} fill="white" align="center" verticalAlign="middle" fontSize={sizeRef / 62} />
                          </Group>
                          <Text text={`${ticketScrollIndex + 1}-${Math.min(ticketScrollIndex + visibleTicketCount, newTicketList.length)}/${newTicketList.length}`} x={widthCanvas * 0.172} y={heightCanvas * 0.362} width={widthCanvas * 0.062} height={heightCanvas * 0.025} fill="black" fontSize={sizeRef / 70} align="right" verticalAlign="middle" />
                        </>
                      )}
                    </Group>
                  </Group>
                  {ticketOverlay && (
                    <Group x={0} y={0}>
                      <Rect x={0} y={0} width={widthCanvas} height={heightCanvas} fill="black" opacity={0.55} onClick={stopTicketBubble} onTap={stopTicketBubble} />
                      <Group x={widthCanvas * 0.28} y={heightCanvas * 0.28} width={widthCanvas * 0.44} height={heightCanvas * 0.34}>
                        <Rect x={0} y={0} width={widthCanvas * 0.44} height={heightCanvas * 0.34} fill="#101820" stroke={ticketOverlay.type === "error" ? "red" : "yellow"} strokeWidth={4} cornerRadius={8} shadowColor="black" shadowBlur={18} shadowOpacity={0.6} />
                        <Text text={ticketOverlay.title} x={widthCanvas * 0.03} y={heightCanvas * 0.035} width={widthCanvas * 0.38} height={heightCanvas * 0.055} fill={ticketOverlay.type === "error" ? "#ff5252" : "#f5c84b"} fontSize={sizeRef / 26} fontStyle="bold" align="center" verticalAlign="middle" />
                        <Text text={ticketOverlay.message} x={widthCanvas * 0.045} y={heightCanvas * 0.115} width={widthCanvas * 0.35} height={heightCanvas * 0.105} fill="white" fontSize={sizeRef / 45} align="center" verticalAlign="middle" />
                        {ticketOverlay.cancelLabel && (
                          <Group x={widthCanvas * 0.055} y={heightCanvas * 0.245} width={widthCanvas * 0.15} height={heightCanvas * 0.06} onClick={closeTicketOverlay} onTap={closeTicketOverlay}>
                            <Rect x={0} y={0} width={widthCanvas * 0.15} height={heightCanvas * 0.06} fill="#d71920" stroke="white" strokeWidth={2} cornerRadius={6} />
                            <Text text={ticketOverlay.cancelLabel} x={0} y={0} width={widthCanvas * 0.15} height={heightCanvas * 0.06} fill="white" fontSize={sizeRef / 43} fontStyle="bold" align="center" verticalAlign="middle" />
                          </Group>
                        )}
                        <Group x={ticketOverlay.cancelLabel ? widthCanvas * 0.235 : widthCanvas * 0.145} y={heightCanvas * 0.245} width={widthCanvas * 0.15} height={heightCanvas * 0.06} onClick={confirmTicketOverlay} onTap={confirmTicketOverlay}>
                          <Rect x={0} y={0} width={widthCanvas * 0.15} height={heightCanvas * 0.06} fill="#148f2b" stroke="white" strokeWidth={2} cornerRadius={6} />
                          <Text text={ticketOverlay.confirmLabel || "OK"} x={0} y={0} width={widthCanvas * 0.15} height={heightCanvas * 0.06} fill="white" fontSize={sizeRef / 43} fontStyle="bold" align="center" verticalAlign="middle" />
                        </Group>
                      </Group>
                    </Group>
                  )}
                </Layer>
              </Stage>
              </>
            ) : (
              <Stage width={window.innerWidth * 0.99} height={window.innerHeight * 0.99}>
                <Layer>
                  <Group x={0} y={0} width={window.innerWidth * 0.99} height={window.innerHeight * 0.99}>
                    <Text x={0} y={0} text="Este Punto Esta Temporalmente Fuera de Servicio, Favor Contactar a su Proveedor" fill="yellow" fontSize={window.innerHeight / 20} align="center" verticalAlign="middle" width={window.innerWidth * 0.99} height={window.innerHeight * 0.99} />
                  </Group>
                </Layer>
              </Stage>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div className="">
          <header>
            <nav>
              <div className="">
                <Link className="vol venta" to="/bet">
                  VENTA
                </Link>
                <Link to="/line" className="vol lin">
                  LINEA
                </Link>
                <Link className="vol res" to="/line-pale">
                  LINEA PALE
                </Link>
                <Link className="vol volvent" to="/venta">
                  VOLUMEN DE VENTAS
                </Link>
                <Link className="vol volvent" to="/player">
                  JUGADORES
                </Link>
                <button className="boton_menu bg-danger" onClick={Logout}>
                  <DoorOpenFill />
                </button>
              </div>
            </nav>
          </header>
          <div className="suspendid">
            <h1 className="carrAc ">Carrera Activa...</h1>
          </div>
        </div>
      );
    }
  }
}
export default Bet;
